<template>
  <div>
    <base-crud
      crudName="Grupo de Usuários"
      newText="Novo Grupo"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="true"
      :enableDelete="true"
      :enableView="false"
      :dataForm="dataForm"
    ></base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data: function() {
    return {
      table: "usersGroups",
      // pages: [],
      // url: '',
      columns: ["id", "title", "company_id", "description", "actions"],
      tableData: ["id", "title", "company_id", "description"],
      options: {
        sortable: ["id", "title", "company_id", "description"],
        filterable: ["id", "title", "company_id", "description"],
        filterByColumn: true,
        debounce: 1000,
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          title: "Titulo",
          company_id: "Empresa",
          description: "Descrição",
          actions: "Ações"
        },

        templates: {
          company_id: function(h, row, index) {
            return row.company ? row.company.company_name : "Sem Nome";
          }
        },
        requestFunction: function(data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["company"];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function(e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        }
      },
      endPoint: "users_groups/",

      dataForm: {}
    };
  },
  components: {
    BaseCrud
  },
  methods: {
    query: function(query) {
      let columns = {
        id: "id",
        title: "title",
        company_id: "company[company_name]",
        description: "description"
      };
      let filters = "";
      $.each(query, function(index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    }
  }
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/UserGroups/Crud.vue